/**
 * AUDIT LOG API — Wrapper del REST Liferay allineato a UsersResourceImpl.java.
 *
 * Contratto backend (rest-openapi.yaml):
 *   - GET /user/auditLog   pagination server-side  -> Page<AccessEntry>
 *     Query params: page (1-based, default 1), pageSize (default 20).
 *
 * Endpoint user-scoped: l'utente è risolto dal Bearer (contextUser), quindi
 * NON c'è groupId (a differenza dei *Api.getAll delle entità di sito).
 * Read-only: nessun create/update/delete.
 */

import type { Page } from '@crm/shared';
import { httpClient } from '../../api/httpClient';
import type { AccessEntry } from './auditLogTypes';

const RESOURCE = '/user/auditLog';

export interface AuditLogListParams {
  page?: number;
  pageSize?: number;
}

export const auditLogApi = {
  getAll: (params?: AuditLogListParams): Promise<Page<AccessEntry>> =>
    httpClient
      .get<Page<AccessEntry>>(RESOURCE, {
        params: params as Record<string, unknown> | undefined,
      })
      .then((r) => r.data),
};
